import React, { useEffect } from 'react';

// GHL (GoHighLevel) forms, shown in a dark pop-up. Each form's submission starts its workflow in GHL.
export const GHL_FORMS = {
  guides: { id: 'UJHlCJBhFOwGhmSMqRM0', name: 'Guide – PDF Resources', height: 610 },
  kinezioletter: { id: 'JWZ8mNTO0WS0apwoXSYF', name: 'KinezioLetter – Sign Up', height: 632 },
  enquiry: { id: 'X0zaqHd3jVvtDgv5A4rO', name: 'Company & Coworking Enquiry', height: 1060 },
  workshop: { id: 'dWQYrI1vJeqNXCpJQsEs', name: 'Workshop – Registration', height: 842 },
};

interface GhlFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  form: { id: string; name: string; height: number };
  title: string;
  intro: React.ReactNode;
}

const GhlFormModal: React.FC<GhlFormModalProps> = ({ isOpen, onClose, form, title, intro }) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = 'unset';
      window.removeEventListener('keydown', onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="popup popup--dark" role="dialog" aria-modal="true" aria-labelledby={`popup-title-${form.id}`}>
        <button className="popup__close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <h2 id={`popup-title-${form.id}`}>{title}</h2>
        <p>{intro}</p>
        {/* Plain iframe: GHL's form_embed.js hides inline forms that are added after page load, as in this pop-up. */}
        <iframe
          src={`https://links.hannakinez.com/widget/form/${form.id}`}
          id={`inline-${form.id}`}
          title={form.name}
          className="ghl-form"
          style={{ height: form.height }}
        />
      </div>
    </div>
  );
};

export default GhlFormModal;
